import { useTerminology } from "@/contexts/TerminologyContext";
import { useTranslation } from "react-i18next";
import {
  Sheet, SheetContent, SheetTitle,
} from "@/components/ui/sheet";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import AddCompanyForm from "@/components/shared/AddCompanyForm";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialName?: string;
  initialData?: Record<string, string>;
  hideOverlay?: boolean;
  onAdd?: (company: {
    id: string;
    name: string;
    website: string;
    location: string;
    industry: string;
    employees: string;
    revenue: string;
    phone: string;
    linkedin: string;
  }) => void;
}

export default function AddCompanyDialog({ open, onOpenChange, onAdd, initialName, initialData, hideOverlay }: Props) {
  const { terminology, singular } = useTerminology();
  const { t } = useTranslation();
  const handleCancel = () => onOpenChange(false);

  const handleCompanyCreated = (company: Parameters<NonNullable<Props['onAdd']>>[0]) => {
    onAdd?.(company);
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={(v) => { if (!v) handleCancel(); else onOpenChange(v); }}>
      <SheetContent expandable className="sm:max-w-[50vw] w-full overflow-y-auto p-0 flex flex-col" hideOverlay={hideOverlay}>
        <VisuallyHidden><SheetTitle>{t("common.addEntity", { entity: singular.companies })}</SheetTitle></VisuallyHidden>
        <AddCompanyForm onCompanyCreated={handleCompanyCreated} onCancel={handleCancel} initialName={initialName} initialData={initialData} />
      </SheetContent>
    </Sheet>
  );
}
